import dynamic from 'next/dynamic'
import Head from 'next/head'
import React from 'react'
import DKExploreHomeVideoEn from '../../components/HomeCompo/DKExploreHomeVideo/DKExploreHomeVideoEn'
import DkStatisticEn from '../../components/HomeCompo/DKStatistic/DkStatisticEn'
import ImageRowEn from '../../components/HomeCompo/ImageRow/ImageRowEn'
import VideosRowEn from '../../components/Elements/VideosRow/VideosRowEn'

const SliderEn = dynamic(
  () => import('../../components/HomeCompo/Slider/SliderEn'),
  {
    ssr: false
  }
)

const EnglishHome = ({ sliderData, videoData }) => {
  return (
    <div className='enFontFamily'>
      <Head>
        <title>About Digikala Group</title>
        <meta name='viewport' content='initial-scale=1.0, width=device-width' />
        <meta charSet='utf-8' />
        <meta
          name='description'
          content='Digikala Group is a technology-based platform ecosystem with the mission of creating memorable E-Commerce experiences for all Iranians.'
        />
        <link rel='icon' type='image/x-icon' href='/faviconNew.svg'></link>
        <meta
          name='robots'
          content='index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large'
        />
        <link rel='canonical' href='https://about.digikala.com/en/' />
        <meta property='og:locale' content='fa_IR' />
        <meta property='og:type' content='website' />
        <meta property='og:title' content='About Digikala Group' />
        <meta property='og:url' content='https://about.digikala.com/en/' />
        <meta property='og:site_name' content='About Digikala Group' />
        <meta
          property='og:image'
          itemProp='image'
          content='https://about.digikala.com/ogImage.jpg'
        />
        <meta property='og:image:width' content='414' />
        <meta property='og:image:height' content='217' />
        <meta property='og:image:alt' content='About Digikala Group' />
        <meta property='og:image:type' content='image/png' />
        <meta
          property='og:site_name'
          content='About Digikala Group'
          key='ogsitename'
        />
        <meta
          property='og:title'
          content='About Digikala Group'
          key='ogtitle'
        />
        <meta
          property='og:description'
          content='Digikala Group is a technology-based platform ecosystem with the mission of creating memorable E-Commerce experiences for all Iranians.'
          key='ogdesc'
        />
        <meta name='twitter:card' content='summary_large_image' />
        <meta name='twitter:title' content='About Digikala Group' />
        <meta name='twitter:site' content='About Digikala Group' />
        <meta
          name='twitter:image'
          content='https://about.digikala.com/ogImage.jpg'
        />
        <meta
          name='twitter:description'
          content='Digikala Group is a technology-based platform ecosystem with the mission of creating memorable E-Commerce experiences for all Iranians.'
        />
      </Head>
      <SliderEn data={sliderData} />
      <DkStatisticEn />
      <DKExploreHomeVideoEn />
      {/* <VideosRowEn data={videoData} /> */}
      <ImageRowEn />
    </div>
  )
}

export default EnglishHome

export async function getServerSideProps (context) {
  try {
    const sliderRes = await fetch(
      `https://about.digikala.com/api/v1/homepage/sliders/en/?reqDate=${Date.now()}&is_published=true&language=en`
    )
    const videosRes = await fetch(
      `https://about.digikala.com/api/v1/videos/?reqDate=${Date.now()}&is_published=true&language=fa`
    )
    const sliderData = await sliderRes.json()
    const videoData = await videosRes.json()
    return {
      props: { sliderData: sliderData, videoData: videoData }
    }
  } catch (error) {
    console.error(error)
    return {
      props: { videoData: [], sliderData: [] }
    }
  }
}
